import React from 'react'
import { WallboxModel } from '../../wallboxes'
import { Stack } from '@mui/material'
import { WallboxCell } from 'src/Libs/e-mobility/charging-sessions/components/WallboxCell'

interface LinkedWallboxesProps {
  linkedWallboxes: WallboxModel[]
}

/**
 * Component that renders a stack of rows, each row representing a wallbox linked to a single charging card.
 *
 * The row itself displays wallbox name + wallbox id if necessary.
 */
export const LinkedWallboxes: React.FC<LinkedWallboxesProps> = ({ linkedWallboxes }) => {
  return (
    <Stack gap={1}>
      {linkedWallboxes.map(wallbox => {
        return <WallboxCell wallboxId={wallbox.wallboxId} key={wallbox.wallboxId} />
      })}
    </Stack>
  )
}
